import { Descriptions, Modal, Spin } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpModal from "./OtpModal";
import { save } from "../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import { formatText } from "../../../../utils";

function VerificationModal({
  open,
  handleCancel,
  handleFetchData,
  setopenVerification,
  handleCancelSingle,
}) {
  const { singlePaymentObj } = useSelector((state) => state.obj);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();

  const [openOtp, setopenOtp] = useState(false);
  async function handleCancelOtp() {
    await setopenOtp(false);
    await setopenVerification(true);
  }
  const [resMess, setResMess] = useState();
  async function handleCancelAll() {
    await setopenOtp(false);
    await setopenVerification(false);
    await handleCancelSingle();
    await setResMess("");
  }

  async function handleOpenOtp() {
    await setopenOtp(true);
    await setopenVerification(false);
  }

  const onFinish = async (data) => {
    const {
      paymentSourceName,
      bankName,
      paymentModeName,
      categoryName,
      subCategoryName,
      paybillName,
      ...restOfData
    } = singlePaymentObj;
    const res = await dispatch(
      save({
        ...restOfData,
        url: "api/v1/payments/save-direct-payment",
      })
    );

    if (res?.payload?.success) {
      if (res?.payload?.data?.result?.hasReviewers) {
        await toast.success(res?.payload?.messages?.message);
        await handleFetchData();
        await handleCancelAll();
      } else {
        await setResMess(res?.payload?.data?.result);
        await handleOpenOtp();
      }
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const itemsBank = [
    {
      key: "1",
      label: "Payment Method",
      children: singlePaymentObj?.pyType,
    },
    {
      key: "2",
      label: "Mode",
      children: singlePaymentObj?.paymentModeName,
    },

    {
      key: "3",
      label: "Source",
      children: singlePaymentObj?.paymentSourceName,
    },

    {
      key: "4",
      label: "Amount",
      children: singlePaymentObj?.payPaymentAmount,
    },
    ...(singlePaymentObj?.paymentModeName === "PESALINK_BANK"
      ? [
          {
            key: "5",
            label: "Bank Name",
            children: singlePaymentObj?.bankName,
          },
          {
            key: "7",
            label: "Account Number",
            children: singlePaymentObj?.payBeneficiaryAccount,
          },
          {
            key: "8",
            label: "Account Name",
            children: singlePaymentObj?.payBeneficiaryDetails,
          },
        ]
      : []),
    {
      key: "7",
      label: "Receiver Number",
      children: singlePaymentObj?.payReceiverMobileNo,
    },
    {
      key: "9",
      label: "Reason",
      children: singlePaymentObj?.payPaymentReason,
    },
    {
      key: "10",
      label: "ID Number",
      children: singlePaymentObj?.payIdNumber,
    },

    {
      key: "11",
      label: "Category",
      children: singlePaymentObj?.categoryName,
    },
    {
      key: "12",
      label: "Sub Category",
      children: singlePaymentObj?.subCategoryName,
    },
  ];

  const itemsMobile = [
    {
      key: "0",
      label: "Payment Type",
      children:<div>{formatText(singlePaymentObj?.pyType)}</div>,
    },
    {
      key: "2",
      label: "Payment Source",
      children: singlePaymentObj?.paymentSourceName,
    },
    {
      key: "3",
      label: "Payment Amount",
      children: singlePaymentObj?.payPaymentAmount,
    },
    {
      key: "5",
      label: "Payment Reason",
      children: singlePaymentObj?.payPaymentReason,
    },
     ...(singlePaymentObj?.payValidate === "YES"
      ? [
           {
      key: "15",
      label: "ID Validation",
      children: singlePaymentObj?.payValidate,
    },
    
        ]
      : []),
   
    {
      key: "6",
      label: "ID Number",
      children: singlePaymentObj?.payIdNumber,
    },
    ...(singlePaymentObj?.paymentModeName === "MPESA"
      ? [
          {
            key: "7",
            label: "Receiver Number",
            children: singlePaymentObj?.payReceiverMobileNo,
          },
        ]
      : []),
    {
      key: "8",
      label: "Category",
      children: singlePaymentObj?.categoryName,
    },
    {
      key: "9",
      label: "Sub Category",
      children: singlePaymentObj?.subCategoryName,
    },
    {
      key: "10",
      label: "Payment Mode",
      children: formatText(singlePaymentObj?.paymentModeName),
    },
    ...(singlePaymentObj?.paymentModeName === "PAYBILL"
      ? [
          {
            key: "11",
            label: "Paybill Name",
            children: singlePaymentObj?.paybillName,
          },
          {
            key: "12",
            label: "Account Number",
            children: singlePaymentObj?.payPaybillAccountNo,
          },
        ]
      : singlePaymentObj?.paymentModeName === "TILL_NUMBER"
      ? [
          {
            key: "13",
            label: "Till Number",
            children: singlePaymentObj?.tillNumber,
          },
        ]
      : []),
  ];
 
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Verification`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
        maskClosable={false}
      >
        <p className="text-[15px] text-[#000] font-[600] mb-8 font-dmSans">
          Would you like to make the following transfer?
        </p>

        <div className="mt-[1.25rem]">
          {singlePaymentObj?.pyType === "BANK" ? (
            <Descriptions
              column={{
              xs: 1,
              sm: 2,
              md: 2,
              lg: 2,
              xl: 2,
              xxl: 2,
            }}
              colon={false}
              title="Single Payment Information"
              items={itemsBank}
            />
          ) : singlePaymentObj?.pyType === "MOBILE_MONEY" ? (
            <Descriptions
              column={{
              xs: 1,
              sm: 2,
              md: 2,
              lg: 2,
              xl: 2,
              xxl: 2,
            }}
              colon={false}
              title="Single Payment Information"
              items={itemsMobile}
            />
          ) : null}
        </div>

        <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center gap-x-2">
            <div className="w-[150px]">
              <button
                key="back"
                type="button"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Previous
              </button>
            </div>

            <div className="w-[150px]">
              <button
                key="submit"
                type="submit"
                className="cstm-btn-2"
                onClick={onFinish}
                disabled={saving}
              >
                {saving ? <Spin /> : "Next"}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <OtpModal
        handleFetchData={handleFetchData}
        open={openOtp}
        handleCancel={handleCancelOtp}
        handleCancelAll={handleCancelAll}
        resMess={resMess}
      />
    </>
  );
}

export default VerificationModal;
